import { Button, Input, LinkWithIcon, LoadingSpinner, Password } from '@vfit/shared/atoms';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDeviceType } from '@vfit/shared/hooks';
import React from 'react';
import { ILoginFormProps } from './loginForm.models';
import { validationSchema } from './loginForm.utils';
import { AnchorContainer, FormContainer, LoadingContainer } from './loginForm.style';

const LoginForm = ({
  isLoading,
  buttonText,
  anchorText,
  onConfirm,
  onAnchorClick,
  onIconClick,
}: ILoginFormProps) => {
  const { isMobile } = useDeviceType();
  const {
    getValues,
    register,
    clearErrors,
    formState: { errors, isValid },
  } = useForm<{ email: string; password: string }>({
    resolver: yupResolver(validationSchema()),
    mode: 'onChange',
  });

  const handleSubmit = () => {
    const inputs = getValues();
    onConfirm(inputs.email, inputs.password);
    clearErrors();
  };

  return (
    <FormContainer className="container">
      <Input
        disabled={isLoading}
        error={errors?.['email']?.message as string}
        label="Username"
        svg="infoAndHelp"
        autoComplete="off"
        {...register('email')}
        btnProps={{ onClick: onIconClick }}
      />
      <Password
        disabled={isLoading}
        label="Password"
        {...register('password')}
        autoComplete="off"
        error={errors?.['password']?.message as string}
      />
      <AnchorContainer>
        <LinkWithIcon text={anchorText} onClick={onAnchorClick} size={isMobile ? '2' : '1'} />
      </AnchorContainer>
      <Button onClick={handleSubmit} disabled={!isValid || isLoading} variant="primary">
        {buttonText}
        {isLoading && (
          <LoadingContainer>
            <LoadingSpinner />
          </LoadingContainer>
        )}
      </Button>
    </FormContainer>
  );
};

export default LoginForm;
